// Storytelling copy for the Results page, keyed to the episode just
// watched — keeps the assessment feeling like a continuation of the
// CyberTales story rather than a generic LMS quiz (P1 product principle).
// Presentation-layer only; nothing here touches the domain model.
interface Narrative {
  pass: string
  fail: string
}

const NARRATIVES: Record<string, Narrative> = {
  'ep-phishing-trap': {
    pass: 'Cyber Smart! You spotted the phishing trap before it caught Amaka.',
    fail: "Not quite — Amaka almost fell for it. Review the warning signs and try again.",
  },
  'ep-simswap-shadows': {
    pass: 'Sharp eyes! You caught the SIM-swap warning signs before they cost Kwame his account.',
    fail: "Kwame's account was drained because the warning signs went unnoticed. Take another look and try again.",
  },
  'ep-password-fortress': {
    pass: 'Fortress built! You know what makes a password actually hard to crack.',
    fail: "Tunde's password fortress had cracks in it. Review the basics and give it another shot.",
  },
}

const DEFAULT_NARRATIVE: Narrative = {
  pass: 'Cyber Smart! You passed this challenge.',
  fail: 'Not quite — review the lesson and try again.',
}

export function getResultNarrative(episodeId: string, passed: boolean): string {
  const narrative = NARRATIVES[episodeId] ?? DEFAULT_NARRATIVE
  return passed ? narrative.pass : narrative.fail
}
